import { Component, ViewContainerRef } from '@angular/core';
import { UserService } from '../../services/user/user.service';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { Router, ActivatedRoute, Params } from '@angular/router';
@Component({
  selector: 'app-ForgotPassword',
  templateUrl: './ForgotPassword.component.html',
  styleUrls: ['./ForgotPassword.component.css']
})
/** login component*/
export class ForgotPasswordComponent {
  validate: boolean;
  emailForgotPassword: any;
  constructor(private readonly userService: UserService,
    private readonly router: Router,
    vcr: ViewContainerRef,
    private readonly toastr: ToastsManager)
  {
    this.toastr.setRootViewContainerRef(vcr);
    this.validate = true;
  }

  ForgotPassword() { 
    this.validate = false; 
    this.userService.ForgotPassword(this.emailForgotPassword).subscribe(
      result => {
        if (result != null) { 
          if (result.status == 0) {
            this.toastr.info(result.message, 'Info');
            this.validate = true;
          } 
          else {
            this.toastr.success(result.message, 'Success');
            setTimeout(() => {
              this.router.navigate(["/login"]);
            }, 2000);
          }
        }
        else {
          alert(result.message);
          this.toastr.error('Error occurred. Please try again', 'Error');
        }

      });
  }
}



// WEBPACK FOOTER //
// ./src/app/login/forgotPassword/ForgotPassword.component.ts